<div class="card">
    <div class="card-header d-flex justify-content-between align-items-start">
        <h4>{{ 'MENU.LAST_CUSTOMERS_REQUESTS' | translate}}</h4>
        <a routerLink="/dashboard/requests-list">{{'VIEW_ALL_FEMALE'|translate}}</a>
    </div>
    <div class="card-body">
        <div *ngIf="requestList?.length < 1">{{'ALERT.ERROR_NOT_FOUND_BARGAINING' | translate}}</div>
        <div *ngFor="let request of requestList" class="row mb-1">
            <div class="col-12">
                <a class="font-weight-medium text-break-line-1 mb-0" [routerLink]="'/dashboard/detail-request/' + request?.id">
                    {{request.request_name}}
                </a>
                <div class="d-flex justify-content-between font-small-3 mt-025">
                    <!--Città-->
                    <span>{{request.city}}
                    </span>
                    <!--Data-->
                    <span>{{_utilService.formatDate(request.date)}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
